import React from 'react'
import DropDown from './dropdown'
import { getKeyOfOpt, lookupOption } from './optionUtils'
import ChildObject from '../ChildObject'
import {
  ReactComponent as CloseIcon,
} from '../../../images/icons/times-pro.svg'

const Hybrid = (props) => {
  const {
    id,
    name,
    label,
    helpText,
    value,
    context,
    rtOptions,
    optionQuery,
    optFields,
    onChange,
    optionKeyName,
    getOptionTextFn,
    topRecordId,
    isInsideModal,
  } = props

  // value is a JS object, but it may be an outdated value -- the key is the bit that's reliable/unchanging.
  const newValue = optionQuery
    ? value
    : lookupOption(getKeyOfOpt(value, optionKeyName), rtOptions)

  const deselect = () => {
    onChange(null)
  }

  if (!newValue) {
    return (
      <DropDown id={id}
                name={name}
                label={label}
                helpText={helpText}
                searchable={true}
                isList={false}
                value={newValue}
                context={context}
                rtOptions={rtOptions}
                optionQuery={optionQuery}
                optFields={optFields}
                onChange={onChange}
                optionKeyName={optionKeyName}
                getOptionTextFn={getOptionTextFn}
                isInsideModal={isInsideModal}
      />
    )
  }

  // Create a temporary ObjectState to wrap newValue
  context.getSelectionContext(name, newValue || -1) // -1 means explicitly delete
  const varDef = context.getVarDef(name) // selection variable definition

  return (
    <div className={'d-flex align-items-end'}>
      <div className={'flex-grow-1'}>
        <ChildObject key={id}
                     id={id}
                     activate={true}
                     name={name}
                     label={label}
                     helpText={helpText}
                     isList={false}
          // eslint-disable-next-line
                     style={'popup'}
                     type={'object'}
                     typeName={varDef.typeName}
                     topRecordId={topRecordId}
                     value={newValue}
                     context={context}
                     getSummaryOverrideFn={getOptionTextFn}
        />
      </div>
      {context.mutable && (
        <div onClick={deselect}>
          <CloseIcon className={'m-2 timesBtn'}/>
        </div>
      )}
    </div>
  )
}

export default Hybrid
